import { jsx as _jsx } from "react/jsx-runtime";
import verticeRedSvg from './vertice_red_logo.svg';
import verticeMultiColorSvg from './vertice_multicolor_logo.svg';
import verticeWhiteSvg from './vertice_white_logo.svg';
import { Box } from '@mui/material';
import { Link } from "react-router-dom";
const RED = "red";
const WHITE = "white";
const MULTI = "multi";
const VerticeSidebarLogo = ({ color }) => {
    const logoSrc = getSvgSrcForColor(color);
    return (_jsx(Link, { to: "/", children: _jsx(Box, { sx: {
                height: '54px',
                width: '100%',
                margin: '20px 10px',
                color: 'black',
            }, children: _jsx("img", { src: logoSrc, alt: "Vertice Logo ", style: { width: '218px', height: '54px' } }) }) }));
};
const VerticeLogo = ({ color, width = '181px', height = '128px' }) => {
    const logoSrc = getSvgSrcForColor(color);
    return (_jsx("img", { src: logoSrc, alt: "Vertice Logo", style: { height: height, width: width } }));
};
const getSvgSrcForColor = (color) => {
    if (color == MULTI) {
        return verticeMultiColorSvg;
    }
    else if (color == WHITE) {
        return verticeWhiteSvg;
    }
    else { // color == RED
        return verticeRedSvg;
    }
};
export { VerticeSidebarLogo, VerticeLogo, RED, WHITE, MULTI };
